<div class="container text-center text-white py-3 pt-5">

    <h2>Contact Us</h2>

</div>
<div class="container card bg-body-tertiary bg-opacity-75">
    <div class="row mb-4">
        
        <div class="col">

            <div class="pt-5 p-3 text-center">

                <h4>WE ARE A PRIVATE MEMBERS ONLY FACILITY</h4>
                <h4>Please contact us for more information</h4>

            </div>

        </div>

    </div>
    <div class="row row-cols-1 row-cols-md-2 g-0">

        <div class="col">

            <ul class="list-unstyled px-5 m-0">
                <li>
                    <h4>Steve Marshall</h4>
                </li>
                <li>
                    <h4><a href="tel:7059552330">705-955-2330</a></h4>
                </li>
                <li class="mt-4">
                    <h4>Ed Vaes</h4>
                </li>
                <li>
                    <h4><a href="tel:2894402200">289-440-2200</a></h4>
                </li>
                <li class="mt-4">
                    <h4><a href="mailto:steve@lakeshorelanding.ca">admin@lakeshorelanding.ca</a></h4>
                </li>
            </ul>
            <div class="p-5">
                <ul class="list-unstyled m-0">
                    <li>
                        <h4>Our Address</h4>
                    </li>
                    <li>
                        1072 Lakeshore Drive
                    </li>
                    <li>
                        Gravenhurst, Ontario
                    </li>
                    <li>
                        P1P 1R2
                    </li>
                </ul>
            </div>

        </div>
        <div class="col">

            <div class="card bg-body-tertiary bg-opacity-75 mb-3">
                <div class="map-wrapper">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d9907.043175665258!2d-79.43886041675228!3d44.96973821657693!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4d2a8fd19a62f73b%3A0xd13093a46f21ecf5!2sLakeshore%20Landing%20Marina!5e1!3m2!1sen!2sca!4v1763655216068!5m2!1sen!2sca"
                    loading="lazy"
                    allowfullscreen=""
                    referrerpolicy="no-referrer-when-downgrade">
                </iframe>
                </div>
            </div>
        
        </div>

    </div>
</div>